// extracted by mini-css-extract-plugin
module.exports = {"icon":"Connect_icon__Umc-m","info":"Connect_info__3wOcA","button":"Connect_button__28TTf"};